import React, {Component} from 'react';
import Modal from 'simple-react-modal';
import {DayPilot, DayPilotCalendar, DayPilotNavigator} from "@daypilot/daypilot-lite-react";
import "./CalendarStyles.css";

const styles = {
  wrap: {
    // display: "flex"
  },
  left: {
    marginRight: "10px"
  },
  main: {
    flexGrow: "1",
    width: "800px",
    marginLeft: "-125px"
  }
};

var _event = null;

class GCalendar extends Component {
  constructor(props) {
    super(props);
    const { onEventSelected } = props;

    this.calendarRef = React.createRef();
    const startDate = new Date()
    const selectionDate = new Date()
    this.state = {
      startDate,
      loading: false,
      selectionDate,
      metadata: null,
      viewType: "Week",
      durationBarVisible: false,
      showWeekPicker: false,
      timeRangeSelectedHandling: "Enabled",
      onTimeRangeSelected: async args => {
        // validation
        let day = args.start.getDayOfWeek()
        if(day == 0 || day == 6) {
          alert('Please select a week day.');
          return
        }

        let hour = args.start.getHours()
        if(hour < 9 || hour > 18) {
          alert('Please select an hour between 9am and 6pm EST.');
          return
        }

        console.log('start', args.start.getDayOfWeek())
        
        const dp = this.calendar;

        if(_event != null) {
          dp.events.remove(_event);
        }

        _event = {
          start: args.start,
          end: args.end,
          id: DayPilot.guid(),
          text: "Consultation"
        }

        this.setState({loading: true})
        fetch("/sapi/gcalendar_check_event", {
          method: 'POST',
          headers: { 'Content-Type' : 'application/json' },
          body: JSON.stringify({ event: _event })
        })
        .then(res => res.json())
        .then(res => {
          this.setState({loading: false});

          // Appointment slot unavailable (busy)
          if(!res.available) {
            dp.events.add({
              start: args.start,
              end: args.end,
              id: "un-" + Date.now(),
              text: "Unavailable",
              backColor: "#cc4125"
            });
            alert('Appointment slot not available, please select another. We apologize for the inconvenience.');
            return;
          }

          // Add event to calendar
          dp.events.add(_event);
          alert('Consultation scheduled for ' + args.start + ' to ' + args.end);

          // Notify parent component of selection
          if(!!onEventSelected) {
            onEventSelected(args);
          }
        })
        .catch(err => this.setState({loading:false}))
      },
      eventDeleteHandling: "Update",
      onEventClick: async args => {
        const dp = this.calendar;
        const { e } = args;
        console.log(JSON.stringify(e));
        // dp.events.update(e);
      },
    };
  }

  get calendar() {
    return this.calendarRef.current.control;
  }

  componentDidMount() {
    fetch("/sapi/gcalendar_get_events")
      .then(res => res.json())
      .then(metadata => {
        this.setState({metadata});
        const { startDate, events } = metadata;
        this.calendar.update({startDate});
      })
      .catch(err => console.log("Backend error: ", err))
  }

  render() {
    const today = new Date()
    return (
      <div style={styles.wrap}>
        {this.state.showWeekPicker && <div style={styles.left}>
          <DayPilotNavigator
            selectMode={"week"}
            showMonths={1}
            skipMonths={1}
            startDate={today}
            selectionDay={today}
            onTimeRangeSelected={ args => {
              this.calendar.update({
                startDate: args.day
              });
            }}
          />
        </div>}
        <div style={styles.left}>
          <button onClick={() => { this.setState({showWeekPicker: !this.state.showWeekPicker})}}>
            {this.state.showWeekPicker ? 'Hide' : 'Show'} Weeks
          </button>
        </div>
        <div style={styles.main}>
          <DayPilotCalendar
            {...this.state}
            ref={this.calendarRef}
          />
        </div>
        <Modal closeOnOuterClick={false} show={this.state.loading}>
          <h1>Checking availability...</h1>
        </Modal>
      </div>
    );
  }
}

export default GCalendar;
